import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getToken } from '../utils/auth';

const MenuContext = createContext({
  menuItems: [], loading: false, hasLoaded: false, reload: () => {},
  resolvedMenus: [], publishResolvedMenus: () => {},
});

export function MenuProvider({ children }) {
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(false);
  // NavMenu, DB menüsü + hardcoded enjeksiyonları birleştirip GERÇEKTE çizdiği ağacı buraya
  // yayınlar. "Favorilerim" yıldızı açık sayfayı bu listeye göre bir menüye bağlar — böylece
  // migration'ı henüz uygulanmamış menüler (Dashboards, Finans ağacı…) de favorilenebilir.
  const [resolvedMenus, setResolvedMenus] = useState([]);
  const publishResolvedMenus = useCallback((items) => {
    setResolvedMenus((prev) => (prev === items ? prev : (items || [])));
  }, []);
  // İlk başarılı/başarısız menü çekimi tamamlandı mı? NavMenu, yükleme bitene kadar
  // hardcoded "tüm menü" fallback'ini GÖSTERMEZ (rol menüsü gelmeden flash olmasın diye).
  const [hasLoaded, setHasLoaded] = useState(false);

  const fetchMenu = useCallback(async () => {
    const token = getToken();
    if (!token) {
      setMenuItems([]);
      setHasLoaded(false);
      return;
    }
    setLoading(true);
    try {
      const res = await fetch('/api/Menu/GetMyMenu', {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        let items = Array.isArray(data) ? data : (data.data ?? []);

        // Raporlar ağacının şekli (grup/ebeveyn/başlık/sıra) ARTIK TEK YERDE: NavMenu'deki
        // REPORT_MENU. Burada ikinci bir kopya tutmak iki kaynağın çelişmesine yol açıyordu —
        // eksik satır enjeksiyonunu ve eski konumların yeni yapıya çekilmesini NavMenu yapar.
        // Kalan tek düzeltme: "Raporlar" kökü çocuk taşıdığı için grup olarak çizilmeli.
        items = items.map(m => (m.id === 9812 ? { ...m, hasChild: true } : m));

        setMenuItems(items);
      } else {
        setMenuItems([]);
      }
    } catch {
      setMenuItems([]);
    } finally {
      setLoading(false);
      setHasLoaded(true);
    }
  }, []);

  // Login olduğunda menüyü çek
  useEffect(() => {
    fetchMenu();

    const onLogin = () => fetchMenu();
    const onLogout = () => { setMenuItems([]); setHasLoaded(false); };

    window.addEventListener('auth:login', onLogin);
    window.addEventListener('auth:logout', onLogout);
    return () => {
      window.removeEventListener('auth:login', onLogin);
      window.removeEventListener('auth:logout', onLogout);
    };
  }, [fetchMenu]);

  return (
    <MenuContext.Provider value={{ menuItems, loading, hasLoaded, reload: fetchMenu, resolvedMenus, publishResolvedMenus }}>
      {children}
    </MenuContext.Provider>
  );
}

export function useMenu() {
  return useContext(MenuContext);
}
